package com.vizio.pay.api

import com.vizio.redwolf.m2m.api.M2MApi
import com.vizio.redwolf.m2m.api.M2MResult
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.M2MEnvironment
import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import kotlin.js.Promise

@JsExport
class M2MJsApi(env: M2MEnvironment, jsClientConfig: JsClientConfig? = null) {
    private val m2mApi = M2MApi(environment = env,
                                appConfig = AppConfig(""),
                                clientConfig = jsClientConfig.toClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS)
    )

    @JsName("requestM2MToken")
    fun requestM2MToken(): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleM2MJsException) {
            m2mApi.requestM2MToken()
        }
    }

    private fun <T: Any> handleM2MJsException(ex: Exception, data: JsExceptionInfo<T>? = null): M2MResult.Error {
        return M2MResult.Error(ResponseHeaders.Invalid, Exception(jsRequestExceptionError))
    }

}
